"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleDriveFilePicker = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `
<button type="button" 
        class="${x => x.buttonClass}" 
        @click="${x => x.openPicker()}"
        ?disabled="${x => x.loading}">
    ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
        <i class="spinner-border spinner-border-sm me-2" role="status">
            <span class="visually-hidden">${'common.loading'.t()}</span>
        </i>
    `)}    
    ${x => x.buttonText}
</button>
`;
require("./styles/layout.scss");
const styles = T.css `.modal.show {
  display: block !important;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.list-group-item {
  transition: all 0.2s ease;
}
.list-group-item:hover {
  background-color: var(--bs-light);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`;
const shadowOptions = { "mode": "open" };
let GoogleDriveFilePicker = class GoogleDriveFilePicker extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.isVisible = false;
        this.pickerApiLoaded = false;
        this.gisLoaded = false;
        this.accessToken = '';
        this.buttonText = 'googleDrive.picker.selectFile'.t();
        this.multiple = false; // Allow multiple file selection
        this.buttonClass = 'btn btn-primary'; // Customizable button class
        this.picker = null;
        this.tokenClient = null;
        this.apiKey = '';
        this.appId = '';
    }
    connectedCallback() {
        super.connectedCallback();
        this.initializeGoogleAPIs();
        this.updateButtonText();
    }
    async initializeGoogleAPIs() {
        try {
            // Load Google APIs according to the official documentation
            await this.loadGooglePickerAPI();
            await this.loadGoogleIdentityServices();
        }
        catch (error) {
            console.error('Failed to initialize Google APIs:', error);
            this.notifyService.notify('googleDrive.picker.initError'.t(), 'error');
        }
    }
    async loadGooglePickerAPI() {
        return new Promise((resolve, reject) => {
            // Load the Google API Loader script first
            if (typeof gapi === 'undefined') {
                const script = document.createElement('script');
                script.src = 'https://apis.google.com/js/api.js';
                script.async = true;
                script.defer = true;
                script.onload = () => {
                    this.onApiLoad();
                    resolve();
                };
                script.onerror = () => reject(new Error('Failed to load Google API script'));
                document.head.appendChild(script);
            }
            else {
                this.onApiLoad();
                resolve();
            }
        });
    }
    async loadGoogleIdentityServices() {
        return new Promise((resolve, reject) => {
            // Load Google Identity Services
            if (typeof google === 'undefined' || !google.accounts) {
                const script = document.createElement('script');
                script.src = 'https://accounts.google.com/gsi/client';
                script.async = true;
                script.defer = true;
                script.onload = () => {
                    this.onGisLoad();
                    resolve();
                };
                script.onerror = () => reject(new Error('Failed to load Google Identity Services script'));
                document.head.appendChild(script);
            }
            else {
                this.onGisLoad();
                resolve();
            }
        });
    }
    onApiLoad() {
        // Use the API Loader script to load google.picker
        gapi.load('picker', () => {
            console.log('Google Picker API loaded successfully');
            this.pickerApiLoaded = true;
        });
    }
    async onGisLoad() {
        try {
            // Get OAuth configuration from backend
            const response = await this.apiService.back.get('settings.google-drive.config');
            if (response && response.success && response.data) {
                const { clientId, apiKey, appId } = response.data;
                this.apiKey = apiKey || '';
                this.appId = appId || '';
                if (clientId) {
                    // Initialize token client according to Google documentation
                    this.tokenClient = google.accounts.oauth2.initTokenClient({
                        client_id: clientId,
                        scope: 'https://www.googleapis.com/auth/drive.file',
                        callback: (response) => {
                            if (response.error !== undefined) {
                                console.error('OAuth error:', response);
                                this.notifyService.notify('googleDrive.picker.authError'.t(), 'error');
                                return;
                            }
                            this.accessToken = response.access_token;
                            this.showPicker();
                        }
                    });
                    this.gisLoaded = true;
                    console.log('Google Identity Services loaded successfully');
                }
                else {
                    console.error('No client ID provided');
                    this.notifyService.notify('googleDrive.picker.configError'.t(), 'error');
                }
            }
            else {
                console.error('Failed to get Google OAuth configuration');
                this.notifyService.notify('googleDrive.picker.configError'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Failed to initialize Google Identity Services:', error);
            this.notifyService.notify('googleDrive.picker.initError'.t(), 'error');
        }
    }
    multipleChanged() {
        this.updateButtonText();
    }
    updateButtonText() {
        this.buttonText = this.multiple
            ? 'googleDrive.picker.selectFiles'.t()
            : 'googleDrive.picker.selectFile'.t();
    }
    /**
     * Get existing access token from user settings if available
     */
    async getExistingAccessToken() {
        try {
            const response = await this.apiService.back.get('settings.google-drive.token');
            if (response && response.success && response.data && response.data.authenticated && response.data.accessToken) {
                console.log('Using existing access token from settings');
                return response.data.accessToken;
            }
        }
        catch (error) {
            console.log('No existing access token available, will request new one');
        }
        return null;
    }
    /**
     * Check if Google Drive is already connected in user settings
     */
    async checkGoogleDriveStatus() {
        try {
            const response = await this.apiService.back.get('settings.google-drive.status');
            if (response && response.success && response.data) {
                return {
                    authenticated: response.data.authenticated,
                    enabled: response.data.enabled
                };
            }
        }
        catch (error) {
            console.log('Could not check Google Drive status');
        }
        return { authenticated: false, enabled: false };
    }
    async openPicker() {
        if (!this.pickerApiLoaded || !this.gisLoaded) {
            this.loading = true;
            this.notifyService.notify('googleDrive.picker.loading'.t(), 'info');
            await this.initializeGoogleAPIs();
            this.loading = false;
            if (!this.pickerApiLoaded || !this.gisLoaded) {
                return;
            }
        }
        try {
            this.loading = true;
            // Check Google Drive connection status first
            const status = await this.checkGoogleDriveStatus();
            if (status.authenticated) {
                // User has connected Google Drive in settings, try to use existing token
                const existingToken = await this.getExistingAccessToken();
                if (existingToken) {
                    // Use existing token from settings
                    this.accessToken = existingToken;
                    this.showPicker();
                    return;
                }
            }
            // Fall back to requesting new permissions if no existing token or not connected
            if (!status.authenticated) {
                // Inform user they need to connect Google Drive in settings first
                this.notifyService.notify('googleDrive.picker.connectFirst'.t(), 'warning');
                console.log('Google Drive not connected in settings, requesting permissions');
            }
            // Request new access token
            if (this.accessToken === null || this.accessToken === '') {
                // Request new access token with consent prompt for new session
                this.tokenClient.requestAccessToken({ prompt: 'consent' });
            }
            else {
                // Skip display of account chooser and consent dialog for existing session
                this.tokenClient.requestAccessToken({ prompt: '' });
            }
        }
        catch (e) {
            console.error('Failed to open picker:', e);
            this.notifyService.notify('googleDrive.picker.statusError'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    showPicker() {
        var _a;
        try {
            console.log('Creating Google Drive Picker with token:', this.accessToken ? 'Token available' : 'No token');
            console.log('API Key available:', this.apiKey ? 'Yes' : 'No');
            console.log('App ID available:', this.appId ? 'Yes' : 'No');
            // Create picker according to Google documentation
            const pickerBuilder = new google.picker.PickerBuilder()
                .addView(google.picker.ViewId.DOCS)
                .setOAuthToken(this.accessToken)
                .setDeveloperKey(this.apiKey)
                .setCallback((data) => this.pickerCallback(data))
                .setOrigin(window.location.protocol + '//' + window.location.host);
            // Set App ID (Cloud project number) as recommended by Google
            if (this.appId) {
                pickerBuilder.setAppId(this.appId);
            }
            // Enable multiselect if multiple attribute is true
            if (this.multiple) {
                pickerBuilder.enableFeature(google.picker.Feature.MULTISELECT_ENABLED);
            }
            // Hide navigation for cleaner interface if only one view
            pickerBuilder.enableFeature(google.picker.Feature.NAV_HIDDEN);
            const picker = pickerBuilder.build();
            picker.setVisible(true);
            console.log('Google Drive Picker opened successfully');
        }
        catch (error) {
            console.error('Failed to show picker:', error);
            this.notifyService.notify('googleDrive.picker.loadingError'.t(), 'error');
            // If picker fails with existing token, try to get a fresh one
            if (this.accessToken && ((_a = error.message) === null || _a === void 0 ? void 0 : _a.includes('invalid_token'))) {
                console.log('Access token appears to be invalid, requesting fresh token');
                this.accessToken = '';
                this.openPicker();
            }
        }
    }
    pickerCallback(data) {
        console.log('Picker callback received:', data);
        if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
            const docs = data[google.picker.Response.DOCUMENTS];
            console.log('Files picked:', docs);
            if (this.multiple) {
                // Multiple files selected
                const files = docs.map((doc) => ({
                    id: doc[google.picker.Document.ID],
                    name: doc[google.picker.Document.NAME],
                    url: doc[google.picker.Document.URL],
                    mimeType: doc[google.picker.Document.MIME_TYPE]
                }));
                this.$emit('files-selected', { files });
                this.notifyService.notify(`${files.length} ${'googleDrive.picker.filesSelected'.t()}`, 'info');
            }
            else {
                // Single file selected
                const doc = docs[0];
                const file = {
                    id: doc[google.picker.Document.ID],
                    name: doc[google.picker.Document.NAME],
                    url: doc[google.picker.Document.URL],
                    mimeType: doc[google.picker.Document.MIME_TYPE]
                };
                this.$emit('file-selected', { file });
                this.notifyService.notify(`${'googleDrive.picker.fileSelected'.t()}: ${file.name}`, 'info');
            }
        }
        else if (data[google.picker.Response.ACTION] === google.picker.Action.CANCEL) {
            console.log('Picker cancelled');
            this.$emit('picker-cancelled');
        }
        else if (data[google.picker.Response.ACTION] === google.picker.Action.LOADED) {
            console.log('Picker loaded successfully');
        }
        else {
            console.log('Picker action:', data[google.picker.Response.ACTION]);
            // Check for errors
            if (data[google.picker.Response.ERROR]) {
                const error = data[google.picker.Response.ERROR];
                console.error('Picker error:', error);
                // Handle authorization errors specifically
                if (error.includes('unauthorized') || error.includes('invalid_token') || error.includes('access_denied')) {
                    console.log('Authorization error detected, access token may be expired');
                    this.notifyService.notify('googleDrive.picker.authError'.t(), 'error');
                    // Clear the token and potentially retry
                    this.accessToken = '';
                }
                else {
                    this.notifyService.notify('googleDrive.picker.error'.t(), 'error');
                }
            }
        }
    }
};
exports.GoogleDriveFilePicker = GoogleDriveFilePicker;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GoogleDriveFilePicker.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GoogleDriveFilePicker.prototype, "isVisible", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GoogleDriveFilePicker.prototype, "pickerApiLoaded", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GoogleDriveFilePicker.prototype, "gisLoaded", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], GoogleDriveFilePicker.prototype, "accessToken", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], GoogleDriveFilePicker.prototype, "buttonText", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Boolean)
], GoogleDriveFilePicker.prototype, "multiple", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], GoogleDriveFilePicker.prototype, "buttonClass", void 0);
exports.GoogleDriveFilePicker = GoogleDriveFilePicker = __decorate([
    (0, client_1.RWSView)('google-drive-file-picker', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], GoogleDriveFilePicker);
GoogleDriveFilePicker.defineComponent();
